// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useRef, useState } from 'react'
import { Button, Paragraph, PlusIcon, CloseIcon, cn } from '@quickmd-llc/design-system'
import { type IcdCodeStaffApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

export type IcdCodeChipProps = {
  code: IcdCodeStaffApiOutContract
  variant: 'current' | 'suggested'
  onClick: () => void
}

export const IcdCodeChip = ({ code, variant, onClick }: IcdCodeChipProps) => {
  const isCurrent = variant === 'current'
  const Icon = isCurrent ? CloseIcon : PlusIcon
  const textRef = useRef<HTMLParagraphElement>(null)
  const [tooltipText, setTooltipText] = useState<string | undefined>(undefined)
  const fullText = `${code.Code} ${code.Description ?? ''}`.trim()

  const handleMouseEnter = () => {
    const el = textRef.current
    if (!el) {
      setTooltipText(undefined)
      return
    }
    const isOverflowing = el.scrollWidth > el.clientWidth
    setTooltipText(isOverflowing ? fullText : undefined)
  }

  return (
    <Button
      priority='secondary'
      size='s'
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      className={cn(
        'w-full justify-start overflow-hidden',
        isCurrent && 'flex-start bg-deep-navy-20 hover:bg-deep-navy-30',
      )}>
      <Icon className={isCurrent ? '!text-text-dark' : 'text-text-highlight'} />
      <Paragraph className={cn('min-w-0 flex-1 font-semibold text-text-highlight', isCurrent && 'text-text-dark')}>
        <span ref={textRef} title={tooltipText} className='block w-full truncate text-start'>
          {code.Code} {code.Description}
        </span>
      </Paragraph>
    </Button>
  )
}
